// same as <NavigationBar/> but without dependencies to session, location, subscription, user, browser
import { Navbar, Nav } from "react-bootstrap";

import { sessionShape, locationShape } from "../../shapes";
import CONFIGURATION from "../../configuration";

import { NavigationAppSwitcher } from "../Navigation/NavigationAppSwitcher";

type Props = {
  name?: string;
  mobileName?: string;
  session?: sessionShape;
  location?: locationShape;
  showAppSwitcher?: boolean;
  configuration?: {
    environment?: string;
  };
};

function ErrorNavigationBar({
  name,
  session = {},
  location,
  mobileName,
  configuration = {},
  showAppSwitcher = true,
}: Props) {
  const navigationItems = null;
  const stripeShadowClassName = session.authenticated
    ? "cyan-stripe navigation-shadow"
    : "cyan-stripe";

  return (
    <div className="navigation">
      <div className={stripeShadowClassName}>
        <div className="container">
          <Navbar collapseOnSelect>
            <div className="row">
              <div className="navigation-header">
                <div className="navigation-toggle">
                  <Navbar.Toggle disabled={!session.authenticated} />
                </div>
                <div className="navigation-title">
                  <a href={`${CONFIGURATION.BASE_URL}`}>
                    <span className="hidden-xs hidden-sm">{name}</span>
                    {configuration.environment === "staging" && (
                      <span className="hidden-xs hidden-sm staging-hint">
                        Staging
                      </span>
                    )}
                    <span className="hidden-md hidden-lg">{mobileName}</span>
                    {configuration.environment === "staging" && (
                      <span className="hidden-md hidden-lg staging-hint">
                        Staging
                      </span>
                    )}
                  </a>
                </div>
                <div className="navigation-logo" />
              </div>
            </div>
            <Navbar.Collapse>
              <div className="row">
                <Nav id="app-navigation">{navigationItems}</Nav>
                {showAppSwitcher && (
                  <Nav id="apps-navigation" pullRight>
                    {session.authenticated && (
                      // @ts-expect-error TS(2322) FIXME: Type 'locationShape | undefined' is not assignable... Remove this comment to see the full error message
                      <NavigationAppSwitcher location={location} />
                    )}
                  </Nav>
                )}
              </div>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
      <div className="navigation-separator" />
    </div>
  );
}

export default ErrorNavigationBar;
